import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardCard from '../components/dashboard-card';
import DashboardTitle from '../components/dashboard-title';
import novadaGarsa from './novada-garsa.jpg';
import novadaGarsa2x from './novada-garsa@2x.jpg';
import veselsAugs from './vesels-augs.jpg';
import veselsAugs2x from './vesels-augs@2x.jpg';
import lad from './lad.jpg';
import lad2x from './lad@2x.jpg';
import css from './index.module.css';

export default function RelatedSystems() {
  const { t } = useTranslation();

  return (
    <div className="mb-6 md:mb-0">
      <DashboardCard>
        <DashboardTitle title={t('pages.dashboard.systems.heading')} />
        <ul className={`${css['list']}`}>
          <li>
            <a
              href="https://www.novadagarsa.lv"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={novadaGarsa}
                srcSet={novadaGarsa + ' 1x,' + novadaGarsa2x + ' 2x'}
                alt={t('pages.dashboard.systems.ng')}
              />
            </a>
          </li>
          <li>
            <a
              href="https://www.veselsaugs.lv"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={veselsAugs}
                srcSet={veselsAugs + ' 1x,' + veselsAugs2x + ' 2x'}
                alt={t('pages.dashboard.systems.va')}
              />
            </a>
          </li>
          <li>
            <a
              href="https://www.lad.gov.lv/lv"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={lad}
                srcSet={lad + ' 1x,' + lad2x + ' 2x'}
                alt={t('pages.dashboard.systems.lad')}
              />
            </a>
          </li>
        </ul>
      </DashboardCard>
    </div>
  );
}
